<script>
    import { computeDebt } from './util';

    import { auth, db } from './firebase';
    import { map } from 'rxjs/operators';

    export let family;
    export let txs;
    export let person;

    const debt = personDebt(family, txs, person.uid);

    function personDebt(family, txs, uid) {
        return txs.pipe(map(ts => {
            const amounts =
                ts.filter(t => t.uid === uid).map(t => t.amount);
            return computeDebt(family, amounts);
        }));
    }

    let newTxInput = 0;
    function newTx() {
        db
            .collection('transactions')
            .add({
                amount: newTxInput,
                family: db.collection('families').doc(family.id),
                time: new Date(),
                uid: person.uid
            })
    }
</script>

<b>{person.name}</b> -
{#await $debt}
    loading...
{:then debt}
    <b>{debt}</b> kč
{/await}
<input type="number" min="0" bind:value={newTxInput}>
<button type="button" on:click={newTx}>Přidat</button>